import React from 'react';
import { trackOutboundLink } from '../utils/analytics';

const WhatsAppIcon = () => {
  // Bottom-right floating icon. Lifts on mobile so it doesn't collide with the sticky CTA bar.
  return (
    <div className='fixed bottom-24 right-1 md:bottom-10 z-50 cursor-pointer '>
      <a
        href='https://wa.me/50685499997?text=Hi%20there!%20I%20am%20interested%20in%20your%20services.'
        target='_blank'
        rel='noopener noreferrer'
        className=''
        onClick={() => trackOutboundLink('https://wa.me/50685499997', 'WhatsApp')}
      >
        <img
          src='https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg'
          alt='WhatsApp'
           loading="lazy"
          className='w-16 h-16 rounded-s-full shadow-lg transition-transform duration-200 hover:scale-110 '
        />
      </a>
    </div>
  );
};

export default WhatsAppIcon;
